import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Paper, Title, Stack, Box } from "@mantine/core";
import { PageLoader } from "@/components/common";
import { FilterForm } from "@/components/filters";
import { filtersApi } from "@/api/client";
import type { Filter } from "@/api/types";

export const Route = createFileRoute("/_authenticated/filters/$id/edit")({
  component: EditFilterPage,
});

function EditFilterPage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data: filter, isLoading } = useQuery({
    queryKey: ["filters", id],
    queryFn: () => filtersApi.get(Number(id)),
  });

  const updateMutation = useMutation({
    mutationFn: (data: Partial<Filter>) => filtersApi.update(Number(id), data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["filters"] });
      navigate({ to: "/filters" });
    },
  });

  if (isLoading || !filter) {
    return <PageLoader />;
  }

  return (
    <Box maw={900} mx="auto">
      <Stack gap="md">
        <Title order={1}>Edit Filter: {filter.name}</Title>

        <Paper p="md" radius="md" withBorder style={{ borderColor: "#0f3460" }}>
          <FilterForm
            filter={filter}
            onSubmit={(data) => updateMutation.mutate(data)}
            isSubmitting={updateMutation.isPending}
          />
        </Paper>
      </Stack>
    </Box>
  );
}
